import Config from '../config/index';
import * as Utils from '../utils/util';
import { getCubeType, getCubeValue } from '../cubeTree/index';

export default function createFrontData(cube: CubeNode): FreeObjMap {
    let cubeType: CubeType = getCubeType(cube);

    switch (cubeType) {
        case 'freezer':
            return makeFreezerFrontCubeData(cube);
            break;

        case 'cabinet':
            return makeCabinetFrontCubeData(cube);
            break;

        case 'sketchpad':
            return makeSketchpadFrontCubeData(cube);
            break;

        case 'shelf':
            return makeShelfFrontCubeData(cube);
            break;

        case 'layer':
            return makeLayerFrontCubeData(cube);
            break;

        case 'beam':
            return makeBeamFrontCubeData(cube);
            break;

        case 'dishrack':
            return makeDishrackFrontCubeData(cube);
            break;

        case 'roof':
            return makeRoofFrontCubeData(cube);
            break;

        case 'goods':
        case 'bafflePlate':
        case 'textarea':
            return makeGoodsFrontCubeData(cube);
            break;

        default:
            return {};
            break;
    }
}

function makeFreezerFrontCubeData(cube: CubeNode): FreeObjMap {
    let shelfKeyMap: ShelfKeyMap = Config.get({
        moduleName: 'shelf',
        key: 'keyMap'
    });

    let result: FreeObjMap = {};

    for (let key in shelfKeyMap) {
        result[key] = Utils.getMapValueByStringKey(cube, shelfKeyMap[key]);
    }

    return Utils.deepCopy(result);
}

function makeCabinetFrontCubeData(cube: CubeNode): FreeObjMap {
    let layerKeyMap: LayerKeyMap = Config.get({
        moduleName: 'layer',
        key: 'keyMap'
    });
    let result: FreeObjMap = {};

    for (let key in layerKeyMap) {
        result[key] = getCubeValue(cube, key);
    }

    return Utils.deepCopy(result);
}

function makeSketchpadFrontCubeData(cube: CubeNode): FreeObjMap {
    let sketchpadKeyMap: SketchpadKeyMap = Config.get({
        moduleName: 'sketchpad',
        key: 'keyMap'
    });

    let result: FreeObjMap = {};

    for (let key in sketchpadKeyMap) {
        result[key] = Utils.getMapValueByStringKey(cube, sketchpadKeyMap[key]);
    }

    return Utils.deepCopy(result);
}

function makeShelfFrontCubeData(cube: CubeNode): FreeObjMap {
    let shelfKeyMap: ShelfKeyMap = Config.get({
        moduleName: 'shelf',
        key: 'keyMap'
    });

    let result: FreeObjMap = {};

    for (let key in shelfKeyMap) {
        result[key] = Utils.getMapValueByStringKey(cube, shelfKeyMap[key]);
    }

    return Utils.deepCopy(result);
}

function makeLayerFrontCubeData(cube: CubeNode): FreeObjMap {
    let layerKeyMap: LayerKeyMap = Config.get({
        moduleName: 'layer',
        key: 'keyMap'
    });
    let result: FreeObjMap = {};

    for (let key in layerKeyMap) {
        result[key] = getCubeValue(cube, key);
    }

    return Utils.deepCopy(result);
}

function makeBeamFrontCubeData(cube: CubeNode): FreeObjMap {
    let layerKeyMap: LayerKeyMap = Config.get({
        moduleName: 'layer',
        key: 'keyMap'
    });
    let result: FreeObjMap = {};

    for (let key in layerKeyMap) {
        result[key] = getCubeValue(cube, key);
    }

    return Utils.deepCopy(result);
}

function makeDishrackFrontCubeData(cube: CubeNode): FreeObjMap {
    let layerKeyMap: LayerKeyMap = Config.get({
        moduleName: 'layer',
        key: 'keyMap'
    });
    let result: FreeObjMap = {};

    for (let key in layerKeyMap) {
        result[key] = getCubeValue(cube, key);
    }

    return Utils.deepCopy(result);
}

function makeRoofFrontCubeData(cube: CubeNode): FreeObjMap {
    let layerKeyMap: LayerKeyMap = Config.get({
        moduleName: 'layer',
        key: 'keyMap'
    });
    let result: FreeObjMap = {};

    for (let key in layerKeyMap) {
        result[key] = getCubeValue(cube, key);
    }

    return Utils.deepCopy(result);
}

function makeGoodsFrontCubeData(cube: CubeNode): FreeObjMap {
    let baseKeyMap: GoodsKeyMap = Config.get({
        moduleName: 'goods',
        key: 'keyMap'
    });
    let getFromGoodsKeyMap: GetFromGoodsKeyMap = Config.get({
        moduleName: 'goods',
        key: 'getFromGoodsKeyMap'
    });
    let result: FreeObjMap = {};

    for (let key in baseKeyMap) {
        result[key] = getCubeValue(cube, key);
    }

    for (let key in getFromGoodsKeyMap) {
        result[key] = getCubeValue(cube, key);
    }

    return Utils.deepCopy(result);
}
